import styled from 'styled-components';
import ButtonProps from '../../../../shared/types/props/button';
import Screen from '../../../../shared/utils/screen';
import Colors from '@shared/assets/style/default/color';

const KeyErase = styled.div<ButtonProps>`
  cursor: pointer;
  float: left;
  height: ${31 * Screen.widthRatio}px;
  left: ${(props) =>
    (props.alternateKeyboard ? 25 : -16) * Screen.widthRatio}px;
  margin-right: ${22 * Screen.widthRatio}px;
  position: relative;
  line-height: 30px;
  padding: ${6 * Screen.widthRatio}px 0px ${6 * Screen.widthRatio}px 0px;
  top: ${(props) =>
    (props.alternateKeyboard ? -42 : -30) * Screen.widthRatio}px;
  width: ${36 * Screen.widthRatio}px;
  background-color: ${(props) =>
    props.focused ? Colors['key'] : Colors['keyBg']};
  border-radius: ${5 * Screen.widthRatio}px;
  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.3);
`;

export default KeyErase;
